module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[4]125.c0ad6fe.woff2";